import { Component, OnInit, ViewChild } from '@angular/core'
// import { AuthService } from 'src/app/services/auth.service'
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component'
import { WbsService } from 'src/app/services/wbs.service'
import { ActivatedRoute, ParamMap, Router } from '@angular/router'
import { FrontEndParams } from '@interserve/igx-angular'
import { environment } from 'src/environments/environment'
import { IsAccountService } from '@interserve/angular'

@Component({
    selector: 'app-create-area-user',
    templateUrl: './create-area-user.component.html',
    styleUrls: ['./create-area-user.component.scss'],
})
export class CreateAreaUserComponent implements OnInit {
    @ViewChild('snackbar', { static: true }) private snackbar!: SnackbarComponent

    public frontendCd = 'areaUserMappingV3'
    public frontendCdHub = 'areaUserMappingNamecardHubV3'
    public title = 'ドキュメント管理／エリアユーザー紐づけ'

    environmentKey = environment.environmentKey

    public apiLoading = false
    public loading = false

    public customerId = ''
    public areaId = ''

    //紐づけライブラリ用
    public mappingParams!: FrontEndParams
    public hubParams!: FrontEndParams

    constructor(
        private wbsService: WbsService,
        private isAccountService: IsAccountService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngOnInit() {
        this.customerId = this.isAccountService.account?.customerId ?? ''

        this.route.paramMap.subscribe((params: ParamMap) => {
            this.areaId = params.get('areaId') ?? ''
        })

        this.initialize()
    }
    async initialize() {
        this.loading = true
        try {
            //フロントエンド設定を紐づけに渡す
            let param = { customerId: this.customerId, areaId: this.areaId, payload: {} }
            this.mappingParams = this.wbsService.setFrontendParams(this.frontendCd, param)
            this.hubParams = this.wbsService.setFrontendParams(this.frontendCdHub, param)
            this.hubParams = {
                appCd: 'documentWbs',
                layoutFrontendCd: this.frontendCdHub,
                items: param,
            }

            this.loading = false
        } catch (error) {
            this.snackbar.error('画面の初期化が失敗しました')
            this.loading = false
        }
    }
    clickSubMenu(value: any) {
        console.log('clickSubMenu:' + value)
    }
    clickPlusElement(value: any) {
        //デフォルトの要素追加ダイアログを使わない場合はここで独自ダイアログを呼び出す（My-ideaの顧客登録などと連携）
        console.log('clickPlusElement:' + value)
    }
    gotoArea() {
        this.router.navigate([`settings/select-area-for-areauser`])
    }
}
